var map = {
	"./avatars/female-avatar-01.png": 9347,
	"./avatars/female-avatar-02.png": 3736,
	"./avatars/female-avatar-03.png": 4865,
	"./avatars/female-avatar-04.png": 6382,
	"./avatars/female-avatar-05.png": 8260,
	"./avatars/female-avatar-06.png": 1948,
	"./avatars/female-avatar-07.png": 4213,
	"./avatars/female-avatar-08.png": 2834,
	"./avatars/female-avatar-09.png": 3339,
	"./avatars/female-avatar-10.png": 6709,
	"./avatars/female-avatar-11.png": 4444,
	"./avatars/female-avatar-12.png": 3447,
	"./avatars/female-avatar-13.png": 958,
	"./avatars/female-avatar-14.png": 7697,
	"./avatars/female-avatar-15.png": 3832,
	"./avatars/female-avatar-16.png": 691,
	"./avatars/female-avatar-17.png": 2938,
	"./avatars/female-avatar-18.png": 717,
	"./avatars/female-avatar-19.png": 6820,
	"./avatars/female-avatar-20.png": 7600,
	"./avatars/female-avatar-21.png": 3353,
	"./avatars/female-avatar-22.png": 9346,
	"./avatars/female-avatar-23.png": 3003,
	"./avatars/female-avatar-24.png": 1012,
	"./avatars/female-avatar-25.png": 2141,
	"./avatars/male-avatar-01.jpg": 2592,
	"./avatars/male-avatar-01.png": 1748,
	"./avatars/male-avatar-02.png": 4207,
	"./avatars/male-avatar-03.png": 9110,
	"./avatars/male-avatar-04.png": 4089,
	"./avatars/male-avatar-05.png": 8336,
	"./avatars/male-avatar-06.png": 3739,
	"./avatars/male-avatar-07.png": 82,
	"./avatars/male-avatar-08.jpg": 1925,
	"./avatars/male-avatar-09.jpg": 744,
	"./avatars/male-avatar-10.jpg": 4518,
	"./avatars/male-avatar-11.jpeg": 5356,
	"./avatars/male-avatar-12.jpeg": 5229,
	"./avatars/male-avatar-13.jpeg": 614,
	"./avatars/male-avatar-14.jpeg": 207,
	"./avatars/male-avatar-15.jpeg": 2616,
	"./avatars/male-avatar-16.jpeg": 1353,
	"./avatars/male-avatar-17.jpeg": 9618,
	"./avatars/male-avatar-18.jpeg": 7547,
	"./avatars/male-avatar-19.png": 1427,
	"./avatars/male-avatar-20.png": 5747,
	"./avatars/male-avatar-21.png": 4170,
	"./avatars/male-avatar-22.png": 8833,
	"./avatars/male-avatar-23.webp": 7590,
	"./avatars/male-avatar-24.png": 4055,
	"./avatars/male-avatar-25.jpeg": 2711,
	"./avatars/male-avatar-26.jpeg": 9341,
	"./avatars/unknown-avatar-01.png": 5189,
	"./avatars/unknown-avatar-02.png": 3710,
	"./avatars/unknown-avatar-03.png": 3207,
	"./avatars/unknown-avatar-04.png": 1064,
	"./avatars/unknown-avatar-05.jpeg": 5534,
	"./avatars/unknown-avatar-06.jpeg": 6843,
	"./avatars/unknown-avatar-07.png": 6675,
	"./avatars/unknown-avatar-08.png": 756,
	"./avatars/unknown-avatar-09.ico": 4652,
	"./avatars/unknown-avatar-10.jpg": 359,
	"./avatars/unknown-avatar-11.jpeg": 1767,
	"./avatars/unknown-avatar-12.png": 4037,
	"./avatars/unknown-avatar-13.svg": 6128,
	"./avatars/unknown-avatar-14.svg": 6271,
	"./avatars/unknown-avatar-15.png": 3914,
	"./avatars/unknown-avatar-16.png": 5025,
	"./avatars/unknown-avatar-17.jpeg": 7045,
	"./avatars/unknown-avatar-18.jpg": 6959,
	"./avatars/unknown-avatar-19.jpg": 2674,
	"./avatars/unknown-avatar-19.png": 7718,
	"./avatars/unknown-avatar-20.jpg": 1650,
	"./avatars/unknown-avatar-21.png": 4783,
	"./avatars/unknown-avatar-22.png": 1220,
	"./avatars/unknown-avatar-23.jpeg": 9589,
	"./icons/python-svgrepo-com.svg": 7496,
	"./school-logos/IITC-01.png": 3857,
	"./school-logos/masa-tlalim.png_400": 3364,
	"./school-logos/michlelet-rivka-beith-habad.png": 1269,
	"./subjects/missions/math/spatial/m000001/rolling-dice01-start.jpg": 8870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;